import React from 'react';
import classnames from 'classnames';

import { APP_ROUTES } from 'constants/routes';
import { useAnalytics } from 'hooks/useAnalytics';

import RecipesListingTemplate from '../RecipesListingTemplate/RecipesListingTemplate';

import type { IRecipesListPageUrlParams, IRecipesPage } from 'types';

import styles from './RecipesPageTemplate.module.scss';

const BREADCRUMBS = [
  {
    href: APP_ROUTES.HOME,
    name: 'NAVIGATION.HOME',
    translate: true
  },
  {
    href: APP_ROUTES.RECIPES_LANDING,
    name: 'NAVIGATION.BLOG.RECIPES.DEFAULT',
    translate: true
  },
];

interface Props {
  className?: string,
  recipesPage: IRecipesPage,
  urlParams: IRecipesListPageUrlParams
}

const RecipesPageTemplate = (props: Props) => {

  const {
    className,
    recipesPage,
    urlParams,
  } = props;

  const {
    details,
    recipes,
    pagination
  } = recipesPage || {};

  const {
    title
  } = details || {};

  const analytics = useAnalytics();

  React.useEffect(() => {
    if (urlParams.searchQuery) {
      analytics.searchRecipes(urlParams.searchQuery);
    }
  }, [urlParams.searchQuery]);

  // Render

  return (
    <RecipesListingTemplate
      className={classnames(styles.root, className)}
      //
      title={title}
      breadcrumbs={[
        ...BREADCRUMBS,
        {
          name: title,
          translate: false,
        }
      ]}
      //
      recipes={recipes}
      pagination={pagination}
      //
      urlParams={urlParams}
      //
      withSearchBox
    />
  );
};

export default RecipesPageTemplate;
